// 🔒 Admin → Tailscale API marshruti: BIRINCHI yuklanadi (fetch/XHR/WebSocket o'ramlari App'dan oldin).
import './apiRoute';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Inter — Flowbite dizayn shrifti, self-hosted (CSP font-src 'self').
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import MobilePanel from './MobilePanel';
import AdminEmuViewer from './AdminEmuViewer';
import LoginPage from './LoginPage';
import TwoFactorSetup from './TwoFactorSetup';
import InvitePage from './InvitePage';
import ProtectedRoute from './ProtectedRoute';
import ErrorBoundary from './ErrorBoundary';
import { AuthProvider } from './AuthContext';
import reportWebVitals from './reportWebVitals';
import { registerSW } from './push';
import { initTheme } from './theme';
import { initI18n } from './i18n';

// Tungi rejim: saqlangan/tizim tanlovini birinchi render'dan OLDIN qo'llash (oq chaqnash bo'lmasin).
initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = () => root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/2fa-setup" element={<ErrorBoundary><ProtectedRoute><TwoFactorSetup /></ProtectedRoute></ErrorBoundary>} />
          <Route path="/invite/:token" element={<ErrorBoundary><InvitePage /></ErrorBoundary>} />
          <Route path="/m" element={<ErrorBoundary><ProtectedRoute><MobilePanel /></ProtectedRoute></ErrorBoundary>} />
          <Route path="/emu" element={<ErrorBoundary><ProtectedRoute><App emulatorOnly /></ProtectedRoute></ErrorBoundary>} />
          <Route path="/emu-view" element={<ErrorBoundary><ProtectedRoute><AdminEmuViewer /></ProtectedRoute></ErrorBoundary>} />
          <Route path="/db" element={<ErrorBoundary><ProtectedRoute><App dbOnly /></ProtectedRoute></ErrorBoundary>} />
          <Route path="/*" element={<ErrorBoundary><ProtectedRoute><App /></ProtectedRoute></ErrorBoundary>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// 🌐 Til: lug'at (GET /i18n/<lang>) render'dan OLDIN yuklanadi (≤1.5s kutadi — o'zbekcha chaqnash
// bo'lmasin); kech kelsa ham DOM'ga o'zi qo'llanadi. Xato bo'lsa UI o'zbekcha (manba) qoladi.
initI18n().catch(() => {}).then(render);

// Register the PWA service worker (push notifications). Safe on all platforms.
registerSW();

reportWebVitals();
